<template>
  <div class="pagination-element">
    <div
      class="content"
      :class="{ active: isActive === page }"
      tabindex="0"
      @click="onClicked"
      @keypress="onClicked"
    >
      {{ page }}
    </div>
  </div>
</template>
<script lang="ts" setup>
const emits = defineEmits<{
  (event: 'onClicked', value: number): void
}>()
const props = withDefaults(
  defineProps<{
    isActive?: number
    page?: number
  }>(),
  {
    isActive: 0,
    page: 1
  }
)
function onClicked() {
  emits('onClicked', props.page)
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';

.pagination-element {
  display: flex;
  width: 48px;
  height: 48px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  color: variables.$color-primary;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
}
.content {
  @include font-mixins.desktop-bold-paragraph;
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  box-sizing: border-box;
  &.active {
    background-color: variables.$color-primary;
    color: white;
  }
  &:focus {
    border: 2px solid variables.$color-primary-light;
    outline-color: variables.$color-primary-light !important;
  }
  &:hover {
    text-decoration-line: underline;
  }
}
</style>
